import $ from 'jquery'
import { initSlides } from '../abstracts/utils'

export default () => {
  $(() => {
    if (! $('body').hasClass('single-project')) return

    let $sectionInfo = $('.section-info')
    if ($sectionInfo.length) {
      let mainSlide = initSlides($sectionInfo.find('.main-thumb.slideshow:not(.slick-initialized.slick-slider)'), 1, false, false, [], {
        fade: true
      })
      initSlides($sectionInfo.find('.sm-thumb.slideshow:not(.slick-initialized.slick-slider)'), 4, true, false)

      $sectionInfo.find('.sm-thumb.slideshow .slick-arrow.slick-prev').on('click', () => {
        mainSlide.slick('slickPrev')
      })
      $sectionInfo.find('.sm-thumb.slideshow .slick-arrow.slick-next').on('click', () => {
        mainSlide.slick('slickNext')
      })
      $sectionInfo.find('.sm-thumb.slideshow .slick-slide .slide__inner').on('click', e => {
        let slide = $(e.target).closest('.slick-slide')
        // smSlide.slick('slickGoTo', slide.attr('data-slick-index'))
        mainSlide.slick('slickGoTo', slide.attr('data-slick-index'))
      })
    }

    let $sectionRelatedProjects = $('.section-related-projects')
    if ($sectionRelatedProjects.length) {
      initSlides($sectionRelatedProjects.find('.slideshow:not(.slick-initialized.slick-slider)'), 4, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ])
    }
  })
}
